import { LogMessage } from '../log-message.model';

export abstract class LogAppender {
  abstract write(logMessage: LogMessage): void;
}
